<div class="inner-content" padding="">
  <div text-center margin>
    <div font-medium style="font-size: 16px !important">
      {{ modalTitle | titlecase }}
    </div>
    <div
      style="font-size: 12px; color: #5b7583"
      *ngIf="modalTitle === 'INVOICE'"
    >
      Payments will be made based on the Invoice Value
    </div>
  </div>
  <ion-card no-box-shadow>
    <ion-list no-margin no-padding *ngIf="docs?.length > 0">
      <ion-item
        [lines]="'none'"
        class="uploaded_file"
        *ngFor="let document of docs"
      >
        <ion-label> {{ document.fileName }} </ion-label>
        <ion-button
          (click)="openFile(document.url)"
          class="view_btn"
          color="primary"
          text-regular
        >
          <ion-icon name="ios-eye" slot="start"></ion-icon> VIEW
        </ion-button>
        <!--<ion-button href="#" text-center color="dark"><ion-icon slot="start" name="star"></ion-icon></ion-button>-->
      </ion-item>
    </ion-list>
    <ion-row *ngIf="docs?.length === 0">
      <ion-col text-center padding margin>
        <ion-text>There are no documents.</ion-text>
      </ion-col>
    </ion-row>
    <ion-row
      (click)="fileInput.click()"
      [hidden]="
        order.status === 'ORDER_COMPLETED' &&
        order.payment.orderPaymentStatus === 'COMPLETED'
      "
    >
      <ion-col no-padding>
        <input
          type="file"
          #fileInput
          ng2FileSelect
          hidden="true"
          [uploader]="uploader"
          (onFileSelected)="onFileSelected($event)"
        />
        <ion-button
          size="large"
          class="uploadBtn"
          no-margin-left
          expand="block"
          color="light"
          text-regular
        >
          <ion-icon name="folder" slot="start"></ion-icon>&nbsp;Attach File
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-card>
  <div text-center *ngIf="isLoading">
    <ion-spinner></ion-spinner>
  </div>
</div>
